<template>
    <CustomHeader :text="$t('offers.depositReturn')" :isPopupCloseBackIcon="true" @closePopup="routerchangeHandle" />
    <div class="offers_page">
        <img :src="dataSet.floatImage" alt="">
        <div class="timer">
            <div class="timeBox" v-if="dataSet.isActivityEnableTime">
                <div class="timeTitle">{{ $t('offers.remainTieTitle') }}</div>
                <div class="timer_countdown">
                    {{ dataSet.days > 0 ? dataSet.days : '' }}<span v-if="dataSet.days > 0" style="margin-right: 25px;">
                        {{ $t('common.days') }}
                    </span>
                    {{ dataSet.hours }}<span> {{ $t('offers.hours') }} </span>
                    {{ dataSet.minutes }}<span> {{ $t('offers.minutes') }} </span>
                    {{ dataSet.seconds }}<span> {{ $t('offers.seconds') }} </span>
                </div>
            </div>
            <div v-else class="timeBox">
                <div class="timeTitle">{{ $t('offers.untilStartPromoTitle') }}</div>
                <div class="timer_countdown">
                    {{ dataSet.days > 0 ? dataSet.days : '' }}<span v-if="dataSet.days > 0" style="margin-right: 25px;">
                        {{ $t('common.days') }}
                    </span>
                    {{ dataSet.hours }}<span> {{ $t('offers.hours') }} </span>
                    {{ dataSet.minutes }}<span> {{ $t('offers.minutes') }} </span>
                    {{ dataSet.seconds }}<span> {{ $t('offers.seconds') }} </span>
                </div>
            </div>
        </div>
        <div class="promo_wrapper">
            <!-- <img src="@/assets/offers/deposit_promotions_title.png" alt=""> -->
            <div class="promo_title">{{ $t('offers.promotionTime') }}</div>
            <div class="promo_title">{{ $t(`offers.${getDayNameFromTimestamp(dataSet.endTime)}`) }}</div>
            <div class="promotion_card_list">
                <PromotionCard :cardData="item" :isActivityEnable="dataSet.isActivityEnableTime"
                    v-for="(item, index) in dataSet.activityList" :key="index"
                    :dayName="getDayNameFromTimestamp(dataSet.endTime)" />
            </div>
        </div>
        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="24" class="title">
                    <div>{{ $t('common.activityTitle') }}</div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="value in dataSet.activityIntro" :key="value">
                {{ value }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">

import { useRouter } from 'vue-router';
import CustomHeader from '../../themeTwo/components/common/customHeader.vue';
import PromotionCard from './components/promotionCard.vue';
import { OffersView } from '@/view/offers/supportScript';
import { defineProps } from 'vue'
const router = useRouter()
const props = defineProps<{
    dataSet: OffersView
}>()


const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}
const routerchangeHandle = () => {
    router.push('/')
    localStorage.setItem('footerPopupOpen', '3')
}
</script>
<style scoped>
.offers_page {
    padding-top: 50px;
}

.offers_page img {
    width: 100%;
}

.timer {
    padding: 5px 20px;
    position: relative;
}

.timeBox {
    border-radius: 10px;
    padding: 10px;
    background: #33243e;
    /* border: 1px solid #dd7a33; */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.timeTitle {
    color: #fd66b1;
    font-size: 16px;
    font-weight: bold;
    /* -webkit-text-stroke: 1px #fd66b1; */
    display: flex;
    justify-content: center;
}

.timer_countdown {
    font-size: 6vw;
    font-weight: bold;
    color: #ffcb52;
    background: #3e2e4b;
    padding: 5px 20px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 10px;
}

.timer_countdown span {
    color: #FFEE00;
    font-size: 2.8vw;
    background-color: #33243e;
    border-radius: 5px;
    padding: 5px;
    margin: 0 5px;
    font-weight: 200;
}

.promo_wrapper {
    /* position: relative; */
    /* display: inline-block; */
    margin-top: 10px;
}

.promo_wrapper img {
    width: 100%;
    display: block;
}

.promo_title {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fd66b1;
    font-weight: bold;
    font-size: 18px;
    z-index: 2;
}

.promotion_card_list {
    /* position: static; */
    margin-top: 5px;
    padding: 0 20px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: #7a4289;
    font-size: 15px;
    display: flex;
    justify-content: flex-start;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px 0px;
}

@media (min-width: 500px) {
    .timer_countdown {
        top: 35px;
        left: 3.6vw;
        font-size: 32px;
        height: 45%;
    }

    .timer_countdown span {
        font-size: 12px !important;
    }
}
</style>